import React, { Component } from 'react';

function PageFooterForKorean(props) {
    let cy = new Date().getFullYear();
    return (
        <footer id="app-footer" className="mescius-bootstrap">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                        <div class="company-info">
                            <div class="img-wrap">
                                <a href="http://mescius.co.kr" target="_blank">
                                    <img src="https://irp.cdn-website.com/c369e33a/dms3rep/multi/MESCIUS_Logo_Style-C_RGB_white_nomargin.svg" alt="MESCIUS 로고" width="200" height="54" />
                                </a>
                            </div>
                            <p class="copyright">©{cy} MESCIUS Inc. All Rights Reserved.</p>
                            <ul class="sns">
                                <li>
                                    <a href="https://www.facebook.com/MESCIUS.KOREA/"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                                </li>
                                <li>
                                    <a href="https://www.youtube.com/channel/UChn5GSeq6vxg0xvQwNFhLHQ"><i class="fa fa-youtube-play" aria-hidden="true"></i></a>
                                </li>
                                <li><a href="https://pf.kakao.com/_ClxiWxb"><i class="fa fa-comment" aria-hidden="true"></i></a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8">
                        <div class="site-nav">
                            <ul>
                                <li>
                                    <h4>제품</h4>
                                    <ul>
                                        <li><a href="https://www.mescius.co.kr/web">For Web 개발자</a></li>
                                        <li><a href="https://www.mescius.co.kr/dotnet">For .NET 개발자</a></li>
                                        <li><a href="https://www.mescius.co.kr/solutions">비즈니스 WEB 개발 솔루션</a></li>
                                    </ul>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <h4>고객 서비스</h4>
                                    <ul>
                                        <li><a href="https://www.mescius.co.kr/docs">개발자 문서</a></li>
                                        <li><a href="https:/dev.mescius.co.kr">개발자 포럼</a></li>
                                        <li><a href="https://www.facebook.com/MESCIUS.KOREA/">페이스북</a></li>
                                        <li><a href="https://pf.kakao.com/_ClxiWxb">카카오톡 채널 추가</a></li>
                                    </ul>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <h4>메시어스 정보</h4>
                                    <ul>
                                        <li><a href="https://www.mescius.com/ko/">MESCIUS 알아보기</a></li>
                                        <li><a href="https://www.mescius.com/ko/recruit/">MESCIUS 채용</a></li>
                                    </ul>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <h4>정책(Policy)</h4>
                                    <ul>
                                        <li><a href="https://www.mescius.co.kr/privacy">EULA</a></li>
                                        <li>
                                            <a href="https://www.mescius.co.kr/%EA%B0%9C%EC%9D%B8%EC%A0%95%EB%B3%B4-%EC%88%98%EC%A7%91-%EB%B0%8F-%EC%9D%B4%EC%9A%A9-%EB%8F%99%EC%9D%98">
                                                개인정보
                                                수집 및 이용 동의
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default PageFooterForKorean;
